import { useCallback, useEffect } from 'react';
import { Outlet, ScrollRestoration, useLocation, useMatches } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Footer from "../@footer";

import Support from '../../components/shared/Support';
import NotificationList from '../../components/drawer/notification';

import { HEADER } from '../../store/constant';
import { ACCESS_TOKEN } from '../../store/types';

import { usePrevious } from '../../hooks/useRoutes';

import { getStorage } from '../../utils/storage';
import GeneralCopyright from '../@footer/GeneralCopyright';



// ==============================|| STYLED ||============================== //
const StyledRoot = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    overflow: 'hidden',
  }
});

const Section = styled('section')(({ theme }) => {
  return {
    flexGrow: 1,
    minHeight: '100%',
    paddingTop: HEADER.MOBILE_HEIGHT,
    [theme.breakpoints.up('lg')]: {
      paddingTop: 0
    },
  }
});


const BgContainer = ({ children }) => {
  return (
    <StyledRoot>
      { children }
    </StyledRoot>
  )
}


// ==============================|| ADMIN LAYOUT ||============================== //

export default function AdminLayout() {
  const location = useLocation();
  // const matches = useMatches();
  const prevLocation = usePrevious(location);
  const { profile } = useSelector(state => state?.account);
  const existToken = getStorage(ACCESS_TOKEN);


  // const crumbs = matches
  //   .filter((match) => Boolean(match.handle?.crumb))
  //   .map((match) => match.handle?.crumb(match.data));

  // console.log("Layout", { crumbs });
  // console.log("Layout", matches);

  useEffect(() => {
    if (prevLocation) {
      // console.log('From:', prevLocation.pathname, prevLocation);
      // console.log('To:', location.pathname, prevLocation);
    }
  }, [location, prevLocation]);
  return (
    <BgContainer>
      <Header />
      <Section>
         <Outlet />
      </Section>
      <Footer copyright={<GeneralCopyright />} />
      <Support />
      { existToken && (!!profile) && (<NotificationList />) }
      {/* <ScrollRestoration getKey={getKey} /> */}
    </BgContainer>
  );
}
